import {
  FORGOT_PASSWORD_SEND_EMAIL_REQUEST,
  FORGOT_PASSWORD_SEND_EMAIL_SUCCESS,
  FORGOT_PASSWORD_SEND_EMAIL_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_SEND_EMAIL_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FORGOT_PASSWORD_SEND_EMAIL_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case FORGOT_PASSWORD_SEND_EMAIL_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
